// common area images
import imgCommonArea from '@/assets/img/management-service/common-area/common_area.jpg'

// villa images
import imgVilla from '@/assets/img/management-service/villa-management-service/villa_management_service.jpg'

export const COMMON_AREA_IMAGE_LIST = [
  imgCommonArea
]

export const VILLA_IMAGE_LIST = [
  imgVilla
]
